export const PAYMENT_APPROVALS_CHANGED_EVENT = 'payment-approvals-changed';

export function notifyPaymentApprovalsChanged(): void {
  window.dispatchEvent(new CustomEvent(PAYMENT_APPROVALS_CHANGED_EVENT));
}
